import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { UploadResourceService } from '../upload-resource.service';
import { IUploadResourceItem } from '../upload-resource.types';
import { UploadResourceProgressHeaderComponent } from './header/upload-resource-progress-header.component';
import { UploadResourceProgressItemComponent } from './item/upload-resource-progress-item.component';
import { UploadResourceProgressTotalComponent } from './total/upload-resource-progress-total.component';

@Component({
  imports: [
    NgIf,
    NgClass,
    NgFor,
    AsyncPipe,
    UploadResourceProgressItemComponent,
    UploadResourceProgressHeaderComponent,
    UploadResourceProgressTotalComponent,
  ],
  selector: 'tdv-upload-resource-progress',
  templateUrl: './upload-resource-progress.component.html',
  styleUrls: ['./upload-resource-progress.component.scss'],
})
export class UploadResourceProgressComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public items?: Array<IUploadResourceItem>;
  public showFullView = false;
  public isMultiUpload?: boolean;
  private prevAmount = 0;

  constructor(private uploadResourceS: UploadResourceService) {}

  ngOnInit(): void {
    this.initItems();
  }

  public trackById(index: number, i: IUploadResourceItem): number {
    return i.uploadId;
  }

  private initItems(): void {
    this.uploadResourceS
      .selectUploadItems()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(r => this.calculateProgress(r));
  }

  private calculateProgress(list: Array<IUploadResourceItem>): void {
    if (list.length > this.prevAmount) {
      this.showFullView = true;
    }
    this.prevAmount = list.length;
    this.items = list.sort((a, b) => {
      return a.uploadId > b.uploadId ? -1 : 1;
    });
    this.isMultiUpload = list.length > 1;
  }
}
